import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { RopePlacementService } from 'services/rope-placement-service';

@autoinject
export class RopePlacementList {
  private tableData: Array<Models.RopePlacement>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private ropePlacementService: RopePlacementService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('ropePlacementListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private async updateView() {
    try {
      const ropePlacements = await this.ropePlacementService.getAll();

      this.ready = true;
      this.tableData = ropePlacements;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('rope-placement-detail', { Id: id });
  }
}
